 // @ts-nocheck

/**
 * @file 文档搜索页翻页组件
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Pagination} from 'antd';
import classNames from 'classnames';
import {PaginationProps} from 'antd/es/pagination';

const itemRender: PaginationProps['itemRender'] = (current, type, originalElement) => {
    if (type === 'prev') {
        return React.cloneElement(originalElement, {}, '上一页');
    }
    if (type === 'next') {
        return React.cloneElement(originalElement, {}, '下一页');
    }
    return originalElement;
};

interface IProps extends PaginationProps {
}

const DocPagination: React.FC<IProps> = React.memo(props => {
    return (
        <Pagination
            itemRender={itemRender}
            showSizeChanger={false}
            {...props}
            className={classNames(props.className, 'paddle-searchall-pagination')}
        />
    );
});

export default DocPagination;
